module.exports = __webpack_public_path__ + "fonts/brelaregular.07323f0.ttf";